import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Container from '@/components/web/Container.vue';
import bannerBread from '@/components/web/bannerBread.vue';
import contentWithImage from '@/components/web/contentWithImage.vue';
import imageContent from '@/components/web/imageContent.vue';
import castingMaterials from '@/components/web/castingMaterials.vue';
import imageAlt from '@/components/web/imageAlt.vue';
import headText from '@/components/web/headText.vue';
import imageAndTable from '@/components/web/imageAndTable.vue';
import imageTableTitle from '@/components/web/imageTableTitle.vue';
import industry from '@/components/web/industry.vue';
import { industryCollection } from '@/data/industryCollection';
import { otherMachinesCollection } from '@/data/otherMachinesCollection';
import castingServices from '@/components/web/castingServices.vue';
import { reactive, ref } from 'vue';
import { useServicesMeta } from '@/composables/useServiceMeta';
import { usePageData } from '@/composables/usePageData'

//使用封装好的 meta 设置
type image = {
    alt: string;
    imgUrl: string;
}

const h1Title = "Services";
const h2Title = "One-Stop Die Casting Technologies, One Standard: On-time Quality"
type plList = {
    pList?: string[],
    liList?: string[]
}
const h2Title2 = "Why Choose China Die Casting Services?";
const h2Text = "China Die Casting Services Capabilities"
const h2Materials = "China Minghe Die Casting Materials"
const h2Surface = "China Minghe Surface Finishes";
const h2Industry = "Applications of MINGHE Die Casting Services";
const h2Cast = "The Advantages of Minghe Die Casting Services";
const h2Case = "The Minghe Case Studies Of Die Casting"
const pAHref = "Go To View More Casting Parts Cases Studies >>>"

//Choose the Best Gravity Casting Supplier
const h2Choose = "Choose the Best Die Casting Service"
const h2CastingServices = "We Provide Casting Services Include:";

export default /*@__PURE__*/_defineComponent({
  __name: 'services',
  setup(__props) {

useServicesMeta();

const bannerImages = ref<image[]>([]);


//服务材料集合
const servicesMaterialsCollection = reactive<pictureTitleTextList[]>([]);
// 明和服务案例集合
const mingHeServicesExamples = reactive<imageAltItem[]>([]);
//CNC加工服务能力的不同类型生产设备集合
const cncMachiningMachinesCollection = reactive<picturetitleItem[]>([]);



//组件传输
//contentWithImage
const pList = ref<string[]>([]);
pList.value = [
    `Die casting is a precision casting method that uses high pressure to force the molten metal into a metal mold with complex shapes. In 1964, the Japan Die Casting Association defined die casting as "a casting method that presses molten alloy into a precision mold at a high temperature, and mass produces high precision and excellent casting surface in a short time." It is also known as Pressure Die Casting. The tensile strength of these materials is nearly double that of ordinary casting alloys. It is more positive for aluminum alloy automobile wheels, frames and other parts that want to be produced with higher-strength impact-resistant materials. significance.`,
    `Want to shorten production cycle and reduce cost of your core project? Integrated multiple advanced technologies, Die Casting Services can simplify the manufacturing process and speed up large batch production of machined components, as well as achieve a higher level of accuracy and On-time Quality.`,
    `Our custom die casting services are bolstered by our extensive Minghe machine library and general breadth of die cast technology. Few can match Minghe Casting in adherence to exacting specifications, or in the re-creation of complex geometries for high volume production of all types of specialized material parts.`
]

const imageList = ref<image[]>([])

imageList.value = [
    {
        alt: 'china-die-casting-services-in-minghe',
        imgUrl: 'https://www.diecastingcompany.com/uploads/2102/china-die-casting-services-in-minghe.jpg'
    },
    {
        alt: 'china-mass-production-die-casting-services-in-minghe',
        imgUrl: 'https://www.diecastingcompany.com/uploads/2102/china-mass-production-die-casting-services-in-minghe.jpg'
    }
];
//imageContent
const plList2 = ref<plList[]>([]);
plList2.value = [
    {
        pList: [`As one of the fastest-growing die casting services China suppliers, the following casting capabilities at Minghe are available to serve your needs of die casting parts, from mass production to precision parts and tooling machining, to end-use production.Minghe meets or exceeds the quality standards of the world's most demanding industries with our state of the art equipment and trained professionals. A few of them include:`]
    },
    {
        liList: [
            "ISO 9001:2015 certified",
            "Fully compliant with the exacting requirements of our customers",
            "Compliance in DFARS materials sourcing requirements",
            "Strict compliance with PPAP and Process FMEA for automotive customers",
            "Skilled in KanBan and other customer driven quality and inventory management systems",
            "ITAR Registered"
        ]
    },
    {
        pList: [`While leading-edge technology is essential, it is only a tool for achieving the same goal we’ve pursued single-mindedly for 35+ years: to perform so reliably that customers confidently choose Minghe Casting as their preferred supplier.`,
            `Customers trust Minghe's expertise to spot manufacturability challenges and offer solutions that avoid bottlenecks.`,
            `Suggesting optimum design for manufacturability can fine-tune an existing component to boost production speed and cut unit cost. Minghe Casting is a logistically ideal source for die casting tasks.`],
    }
]

const imageList2 = ref<image[]>([])

imageList2.value = [
    {
        alt: 'Why Choose China Die Casting Services?',
        imgUrl: '	https://www.diecastingcompany.com/uploads/2102/why-choose-china-die-casting-service.jpg'
    }
]

//ImageAndTable
const pText = [`Minghe Casting offers and is capable of producing both medium and long-run projects when providing our die casting services. Minghe Casting has supplied the industry's leading die casting services for more than 35 years in a variety of technology for a wide range of applications.`];


//castingMaterials
const pMaterials = ["Minghe Die Casting services working with Aluminum、Zinc and Other."]

//imageTableTitle
const pSurface = [`You can choose a wide selection of metal surface finishing services after machining at Minghe die casting manufacturer to improve the parts appearance, surface smoothness, corrosion resistance and other performance of your die casting parts.`];

//industry
const pIndustry = [`Die Casting parts are all around you, they may be important components of your car and also can perform vital functions in your electrical equipment. Minghe is an accomplished casting supplier that engaged in a broad range of die casting applications.`];

//cast
const liList = [
    "Cold chamber die casting machine can die-cast 50 to 90 times per hour.",
    "Hot chamber die casting machine can die-cast 400 to 900 times per hour.",
    "The general tolerance class of die casting parts is IT13~IT15 in GB/T 1800-2009, and higher precision can reach IT10~W 1 1.",
    "Surface finish (Ra) ranges from 3.2~1.6μm, and locally can be up to 0.8μm.",
    "Die castings have high mechanical properties.",
    "The minimum wall thickness of aluminum alloy die-casting parts is 0.5mm.",
    "The minimum wall thickness of zinc alloy die castings can achieve 0.3mm.",
    "Parts of other materials can be embedded in die castings. Complex fasteners or inserts can be included in the final component, saving valuable material and processing costs.",
    "Complex shapes of parts can be obtained, improving part performance. Additionally, assembly work is reduced.",
    "Durable and dimensionally stable die casting parts can be obtained with specified shapes, requiring little to no machining.",
    "Die casting parts can have many finishing techniques and surfaces, with the process capable of achieving smooth or textured part surfaces."
];
const imageCastList = ref<image[]>([])
imageCastList.value = [
    {
        alt: 'The Advantages of Minghe Die Casting Services',
        imgUrl: 'https://www.diecastingcompany.com/uploads/2102/the-advantages-of-minghe-die-casting-services.jpg'
    }
]

//ImageAlt
const pCase = [`You have a complex part design, Minghe Casting Company can help you turn it into a reality. With the right equipment, strong technical knowledge, and a focus on quality.. From tool design to finishing and then on to shipment, Minghe Casting ensure that every project is completed to a high standard and that your orders are delivered on time, every time. `];
const pChoose = [`Currently, our die casting parts are exported to America, Canada, Australia, United Kingdom, Germany, France, Sout Africa, and many other countries all over the world. We are ISO9001-2015 registered and also certified by SGS.`,
    `Custom china die casting service provides durable and affordable castings that meet your specifications for automotive, medical, aerospace, electronics, food, construction, security, marine, and more industries. Fast to send your inquiry or submit your drawings to get a free quote in the shortest time.Contact us or Email sales@hmminghe.com to see how our people, equipment and tooling can bring the best quality for the best price for your die casting project.`
];

//service
const pCastingService = [`Minghe Casting services working with sand casting、metal casting 、investment casting lost foam casting, and more.`
]

// 数据填充函数
const populateCollections = () => {
    bannerImages.value = [{ imgUrl: 'https://c74.hongcdn.com/uploads/2102/china-die-casting-services-!j.webp', alt: 'China Die Casting Services - Order Custom Die Casting Online' },];

    servicesMaterialsCollection.push(
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/china-minghe-aluminum-die-casting.jpg", alt: "china-minghe-aluminum-die-casting", title: "Aluminum Die Casting", textList: ["A360", "A380", "ADC6", "ADC10", "ADC12", "ALSi12", "ALSi9Cu3"] },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/china-minghe-zinc-die-casting.jpg", alt: "China Minghe Zinc-die-casting", title: "Zinc Die Casting", textList: ["Zamak3", "Zamak5", "Zamak8", "Zamak12"] },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/china-magnesium-die-casting.jpg", alt: "China Magnesium-Die-Casting", title: "Magnesium Die Casting", textList: ["AM50A", "AM60B", "AZ91D", "AZ63A"] },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/china-minghe-other-die-casting-material.jpg", alt: "China MINGHE other-die-casting-material", title: "Other Casting Material", textList: ["Titanium", "Copper", "Bronze", "Steel", "Stainless Steel", "Foundry Iron"] }
    );

    mingHeServicesExamples.push(
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-1.jpg", alt: "The Minghe Case Studies Of Die Casting (1)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-2.jpg", alt: "The Minghe Case Studies Of Die Casting (2)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-3.jpg", alt: "The Minghe Case Studies Of Die Casting (3)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-4.jpg", alt: "The Minghe Case Studies Of Die Casting (4)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-5.jpg", alt: "The Minghe Case Studies Of Die Casting (5)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-6.jpg", alt: "The Minghe Case Studies Of Die Casting (6)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-7.jpg", alt: "The Minghe Case Studies Of Die Casting (7)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-8.jpg", alt: "The Minghe Case Studies Of Die Casting (8)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-9.jpg", alt: "The Minghe Case Studies Of Die Casting (9)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-10.jpg", alt: "The Minghe Case Studies Of Die Casting (10)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-11.jpg", alt: "The Minghe Case Studies Of Die Casting (11)" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2107/the-minghe-case-studies-of-die-casting-12.jpg", alt: "The Minghe Case Studies Of Die Casting (12)" }
    );

    cncMachiningMachinesCollection.push(
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/painting.jpg",
            alt: "painting",
            title: "Painting"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/passivation.jpg",
            alt: "passivation",
            title: "Passivation"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/electroplating.jpg",
            alt: "electroplating",
            title: "Electroplating/Plating"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/powder-coating.jpg",
            alt: "powder-coating",
            title: "Powder coating/Powder coat"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/anodizing.jpg",
            alt: "anodizing",
            title: "Anodizing/Anodized"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/polishing.jpg",
            alt: "polishing",
            title: "Polishing"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/black-oxide.jpg",
            alt: "black-oxide",
            title: "Black oxide"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/conversion-coating.jpg",
            alt: "conversion-coating",
            title: "Conversion coating"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/bead-blasting.jpg",
            alt: "Bead blasting",
            title: "Bead blasting/Bead blast"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/abrasive-blasting.jpg",
            alt: "Abrasive blasting",
            title: "Abrasive blasting/sandblasting"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/thermal-spraying.jpg",
            alt: "Thermal Spraying",
            title: "Thermal Spraying"
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2101/surface-hardening.jpg",
            alt: "Surface Hardening",
            title: "Surface Hardening"
        }
    );
};

usePageData(populateCollections);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Container, null, {
    "header-banner": _withCtx(() => [
      _createVNode(bannerBread, { "banner-images": bannerImages.value }, null, 8, ["banner-images"])
    ]),
    content: _withCtx(() => [
      _createVNode(contentWithImage, {
        "p-list": pList.value,
        "image-list": imageList.value,
        "content-span": 12,
        imageSpan: 6,
        "out-h1": h1Title,
        "h2-title": h2Title
      }, null, 8, ["p-list", "image-list"]),
      _createVNode(imageContent, {
        "pl-list": plList2.value,
        "image-list": imageList2.value,
        "content-span": 12,
        imageSpan: 12,
        "out-h2": h2Title2
      }, null, 8, ["pl-list", "image-list"]),
      _createVNode(imageAndTable, {
        h2Title: h2Text,
        pTitle: pText,
        tableImageCollection: _unref(otherMachinesCollection),
        "table-image": false,
        span: 8,
        center: true,
        wrap: true,
        "title-center": true,
        "has-link": true
      }, null, 8, ["tableImageCollection"]),
      _createVNode(castingMaterials, {
        "h2-title": h2Materials,
        "casting-materials": servicesMaterialsCollection,
        "title-center": true,
        "p-title": pMaterials
      }, null, 8, ["casting-materials"]),
      _createVNode(imageTableTitle, {
        "has-arrow": true,
        h2Title: h2Surface,
        pTitle: pSurface,
        ImageTitleCollection: cncMachiningMachinesCollection,
        "table-image": false,
        span: 6,
        center: true,
        strong: true,
        "title-center": true
      }, null, 8, ["ImageTitleCollection"]),
      _createVNode(industry, {
        industryCollection: _unref(industryCollection),
        "h2-title": h2Industry,
        "p-title": pIndustry
      }, null, 8, ["industryCollection"]),
      _createVNode(contentWithImage, {
        "use-li": true,
        "li-list": liList,
        "image-list": imageCastList.value,
        "content-span": 12,
        imageSpan: 12,
        "out-h2": h2Cast
      }, null, 8, ["image-list"]),
      _createVNode(imageAlt, {
        imageAltCollection: mingHeServicesExamples,
        "h2-title": h2Case,
        "p-title": pCase,
        span: 6,
        "p-a-href": pAHref
      }, null, 8, ["imageAltCollection"]),
      _createVNode(headText, {
        "h2-title": h2Choose,
        "p-list": pChoose
      }),
      _createVNode(castingServices, {
        "h2-title": h2CastingServices,
        "p-title": pCastingService
      })
    ]),
    _: 1
  }))
}
}

})